import React from 'react';
import css from './SectionSpecifications.module.css';

const buildSpecifications = publicData => ({
  speed: publicData?.speed || publicData?.fps,
  drawLength: publicData?.drawLength,
  drawWeight: publicData?.drawWeight,
  letOff: publicData?.letOff,
  axleToAxle: publicData?.axleToAxle || publicData?.ata,
  massWeight: publicData?.massWeight || publicData?.weight,
  braceHeight: publicData?.braceHeight,
  ibo: publicData?.ibo,
});

// Callers that need to know whether this section will render anything (e.g. to decide
// if a "details" entry point is worth showing) should use this instead of duplicating
// the field mapping above.
export const hasSpecifications = publicData => {
  const specifications = buildSpecifications(publicData);
  return Object.values(specifications).some(val => val != null && val !== '');
};

const SectionSpecifications = props => {
  const { publicData } = props;

  const specifications = buildSpecifications(publicData);

  if (!hasSpecifications(publicData)) {
    return null;
  }

  const renderSpecRow = (label, value, unit = '') => {
    if (!value) return null;
    return (
      <div className={css.specRow} key={label}>
        <span className={css.specLabel}>{label}</span>
        <span className={css.specValue}>{value}{unit}</span>
      </div>
    );
  };

  return (
    <div className={css.root}>
      <div className={css.specsHeader}>Specifications</div>

      <div className={css.specsGrid}>
        {renderSpecRow('Speed', specifications.speed, ' fps')}
        {renderSpecRow('Draw Length', specifications.drawLength, '"')}
        {renderSpecRow('Draw Weight', specifications.drawWeight)}
        {renderSpecRow('Let Off', specifications.letOff)}
        {renderSpecRow('Axle to Axle', specifications.axleToAxle)}
        {renderSpecRow('Mass Weight', specifications.massWeight, ' lbs')}
        {renderSpecRow('Brace Height', specifications.braceHeight)}
        {renderSpecRow('IBO', specifications.ibo)}
      </div>
    </div>
  );
};

export default SectionSpecifications;
